import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { sendNewRelicMessage } from '../../utils/NewRelicUtils';
import BaseCommand from './BaseCommand';
import { Component, ContextType, DropInPaymentsCommandNames, ErrorType, fireLogEvent, fireStatusUpdate, Namespace, ProductType, SpecType, StatusTypes, sendRioEvent } from '@chegg/commerce-utils';
import { ORDER_SUCCESS } from '../../constants/AppConstants';
import { logAdobeOrderConfirmationPixel } from '../../redux/adobeAnalytic/adobeAnalytic.action';
import { clearCartInfo } from '../../redux/cart/cart.slice';
import { clearMessage } from '../../redux/message/message.slice';
import { saveUiConfigs } from '../../redux/config/config.slice';
import { CheckoutStatus } from '../interfaces';
import { OptimizelyEvents } from '../../constants/OptimizelyConstants';
import { trackOptimizely } from '../../utils/OptimizelyUtil';
import * as optimizelyWeb from '../../utils/OptimizelyWebUtils';
import { sendRio2PurchaseEvent } from '../../utils/RioEvents';
export var BilldeskResponseHandlerCommand = /*#__PURE__*/function (_BaseCommand) {
  function BilldeskResponseHandlerCommand() {
    _classCallCheck(this, BilldeskResponseHandlerCommand);
    return _callSuper(this, BilldeskResponseHandlerCommand, arguments);
  }
  _inherits(BilldeskResponseHandlerCommand, _BaseCommand);
  return _createClass(BilldeskResponseHandlerCommand, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;
        var response, responseCheckoutStatus, _loop, _ret;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.input.data.status === 200)) {
                _context2.next = 9;
                break;
              }
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var _response$data;
                var _items$, _this2$state, _this2$state$config, fireRioPurchaseEvent, rioNamespace, items, productType, _response, data, _ref, adobeData, orderKey, rio, _ref2, orderSummary, productItem, _this2$state$config2, country, environment, userAction, referrer, _productItem$, externalId, currency, trackAttributes;
                return _regeneratorRuntime.wrap(function _loop$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return _this2.client.checkoutAPI.checkoutStatus(_this2.state.cart.cartId);
                    case 2:
                      response = _context.sent;
                      responseCheckoutStatus = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.checkoutStatus;
                      if (!(response.data && (responseCheckoutStatus === CheckoutStatus.AWAITING_PAYMENT || responseCheckoutStatus === CheckoutStatus.IN_PROGRESS))) {
                        _context.next = 9;
                        break;
                      }
                      _context.next = 7;
                      return new Promise(function (resolve) {
                        return setTimeout(resolve, 1000);
                      });
                    case 7:
                      _context.next = 27;
                      break;
                    case 9:
                      if (!(response.data && responseCheckoutStatus === CheckoutStatus.COMPLETED)) {
                        _context.next = 24;
                        break;
                      }
                      _this2$state = _this2.state, _this2$state$config = _this2$state.config, fireRioPurchaseEvent = _this2$state$config.fireRioPurchaseEvent, rioNamespace = _this2$state$config.rioNamespace, items = _this2$state.cart.items;
                      productType = (_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.productType;
                      _response = response, data = _response.data;
                      _ref = data, adobeData = _ref.adobeData, orderKey = _ref.orderKey, rio = _ref.rio;
                      if (rio && rio.clickstream_purchase) {
                        sendRio2PurchaseEvent({
                          cartId: _this2.state.cart.cartId,
                          data: rio.clickstream_purchase
                        });
                        if (fireRioPurchaseEvent) {
                          sendRioEvent({
                            info: JSON.stringify(rio.clickstream_purchase),
                            specType: SpecType.PURCHASE,
                            callback: function callback(logObj) {
                              return fireLogEvent(logObj, Namespace.DROP_IN_PAYMENTS);
                            },
                            namespace: rioNamespace
                          });
                        }
                      }
                      if (adobeData) {
                        _context.next = 18;
                        break;
                      }
                      sendNewRelicMessage('Order placement call did not return Adobe Transaction and Cart data.');
                      return _context.abrupt("return", {
                        v: void 0
                      });
                    case 18:
                      _this2.sendOrderPlacedLog(false);
                      _this2.dispatch(logAdobeOrderConfirmationPixel({
                        adobeData: adobeData,
                        callback: _this2.adobeCallback,
                        callbackData: {
                          cartId: _this2.state.cart.cartId,
                          orderKey: orderKey || '',
                          token: response.data.token
                        }
                      }));
                      if (_this2.optimizelyClient) {
                        _ref2 = response.data, orderSummary = _ref2.orderSummary, productItem = _ref2.items;
                        _this2$state$config2 = _this2.state.config, country = _this2$state$config2.country, environment = _this2$state$config2.environment, userAction = _this2$state$config2.userAction, referrer = _this2$state$config2.referrer;
                        _productItem$ = productItem[0], externalId = _productItem$.externalId, currency = _productItem$.currencyName;
                        trackAttributes = {
                          externalId: externalId,
                          currency: currency,
                          environment: environment,
                          country: country,
                          productFamily: productType,
                          checkoutAction: userAction,
                          referrer: referrer
                        };
                        _this2.optimizelyClient.onReady().then(function () {
                          var eventTags = {
                            revenue: orderSummary.total * 100
                          };
                          trackOptimizely({
                            optimizelyClient: _this2.optimizelyClient,
                            eventTags: undefined,
                            eventKey: OptimizelyEvents.ALL_PURCHASE,
                            trackAttributes: trackAttributes
                          });
                          if (productType == ProductType.CHEGG_STUDY) {
                            trackOptimizely({
                              optimizelyClient: _this2.optimizelyClient,
                              eventTags: eventTags,
                              eventKey: OptimizelyEvents.CS_PURCHASE,
                              trackAttributes: trackAttributes
                            });
                          } else {
                            if (productType == ProductType.BUNDLE) {
                              trackOptimizely({
                                optimizelyClient: _this2.optimizelyClient,
                                eventTags: eventTags,
                                eventKey: OptimizelyEvents.CSP_PURCHASE,
                                trackAttributes: trackAttributes
                              });
                            }
                          }
                        });
                      }
                      optimizelyWeb.sendPurchaseEvent(productType);
                      _context.next = 27;
                      break;
                    case 24:
                      _this2.dispatch(saveUiConfigs({
                        showUpiProcessing: false
                      }));
                      console.log('error');
                      _this2.sendErrorEvent();
                    case 27:
                    case "end":
                      return _context.stop();
                  }
                }, _loop);
              });
            case 2:
              if (!(!response || !response.data || responseCheckoutStatus !== CheckoutStatus.COMPLETED && responseCheckoutStatus !== CheckoutStatus.FAILED)) {
                _context2.next = 9;
                break;
              }
              return _context2.delegateYield(_loop(), "t0", 4);
            case 4:
              _ret = _context2.t0;
              if (!_ret) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", _ret.v);
            case 7:
              _context2.next = 2;
              break;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
    /**
     * Send a log to NR to track that an order was placed.
     * @param orderAlreadyPlaced indicates if this order was already placed in the past but the order placed log was not fired.
     */
  }, {
    key: "sendOrderPlacedLog",
    value: function sendOrderPlacedLog(orderAlreadyPlaced) {
      var _this$state$cart = this.state.cart,
        items = _this$state$cart.items,
        externalId = _this$state$cart.externalId;
      var _this$state$upiMopMod = this.state.upiMopMode,
        type = _this$state$upiMopMod.type,
        accountType = _this$state$upiMopMod.accountType;
      var config = this.state.config;
      var couponCode = config.couponCode,
        coupon = config.coupon;
      var addCouponStatus = coupon.addCouponStatus;
      var appliedCoupon = addCouponStatus === 'SUCCESS' && couponCode && couponCode.length > 0 ? couponCode : null;
      var successObject = {
        productType: items[0].productType,
        externalId: externalId
      };

      /*
        If the order has already been placed then we cannot use data from our store as it
        could've changed since the original order was placed. E.G. if user creates a new MOP
        and tries again. ProductType and ExternalId will not change without a page refresh.
      */
      if (!orderAlreadyPlaced) {
        successObject['paymentMethod'] = accountType;
        if (type) successObject['cardType'] = type;
        if (appliedCoupon) successObject['couponCode'] = appliedCoupon;
      }
      sendNewRelicMessage(ORDER_SUCCESS, successObject);
    }

    //We cannot use this.dispatch here because the dispatch hook expires
    //when the redux logic terminates leading to confusing bugs
    //Keeping adobe logic here since it's related to completing an order.
  }, {
    key: "adobeCallback",
    value: function adobeCallback(dispatch, hostPayload) {
      var cartId = hostPayload.cartId,
        token = hostPayload.token,
        orderKey = hostPayload.orderKey;
      fireStatusUpdate([{
        status: StatusTypes.SUCCESS,
        command: DropInPaymentsCommandNames.PLACE_ORDER,
        payload: {
          component: Component.COMMAND_MANAGER,
          context: ContextType.DROP_IN_PAYMENTS,
          data: {
            cartId: cartId,
            token: token,
            orderKey: orderKey
          }
        }
      }], Namespace.DROP_IN_PAYMENTS);
      dispatch(clearCartInfo());
      //Upon successful order, clear any error messaging.
      dispatch(clearMessage());
    }

    // Send error event
  }, {
    key: "sendErrorEvent",
    value: function sendErrorEvent() {
      fireStatusUpdate([{
        status: StatusTypes.ERROR,
        command: DropInPaymentsCommandNames.BILLDESK_RESPONSE_HANDLER,
        payload: {
          errors: [{
            code: 'PM-009',
            message: 'Something went wrong. Please try again later or',
            type: ErrorType.SERVER
          }]
        }
      }], Namespace.DROP_IN_PAYMENTS);
    }
  }]);
}(BaseCommand);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/commandManager/commands/BilldeskResponseHandlerCommand.js
// module id = 4696
// module chunks = 11